<script>
export default {
  name: "Mb",
  inject: ['states'],
  render() {
    return !this.states.isMobile ? null : this.$slots.default({});
  }
}
</script>

<style scoped>

</style>